import styled from "styled-components";

export const Container = styled.div`
    align-self: stretch;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding: 18px 22px 40px;
    font-family: Mulish;

    ::-webkit-scrollbar { width: 8px; }
    ::-webkit-scrollbar-thumb { background-color: #BABABA; border-radius: 5px; }
`;

export const State = styled.div`
    padding: 40px 12px;
    text-align: center;
    color: #8A94A6;
    font-size: 0.9rem;
`;

export const HeadRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 6px;
`;

export const Title = styled.h2`
    margin: 0;
    font-size: 1.15rem;
    font-weight: 800;
    color: #2B3240;
`;

export const SubTitle = styled.span`
    color: #8A94A6;
    font-size: 0.82rem;
`;

export const HeadActions = styled.div`
    display: flex;
    gap: 10px;
`;

export const GhostBtn = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: none;
    background: #384250;
    color: #FFFFFF;
    font-family: Mulish;
    font-size: 0.8rem;
    font-weight: 700;
    padding: 8px 14px;
    border-radius: 8px;
    cursor: pointer;
    &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

export const PrimaryBtn = styled(GhostBtn)`
    background: #2F80ED;
`;

export const CapacityCard = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    background: #FFFFFF;
    border: 1px solid #EEF1F6;
    border-radius: 14px;
    padding: 14px 18px;
    margin: 14px 0;
`;

export const CapacityIcon = styled.span`
    color: #2B3240;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    flex: 0 0 auto;
`;

export const CapacityMain = styled.div`
    flex: 1;
    min-width: 0;
`;

export const CapacityTop = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.82rem;
    font-weight: 700;
    color: #2B3240;
    margin-bottom: 6px;
`;

export const Bar = styled.div`
    height: 8px;
    border-radius: 6px;
    background: #EEF1F6;
    overflow: hidden;
`;

export const BarFill = styled.div`
    height: 100%;
    width: ${(p) => Math.min(100, Math.max(0, p.$pct || 0))}%;
    background: #22C55E;
`;

export const Stats = styled.div`
    display: flex;
    gap: 22px;
`;

export const Stat = styled.div`
    text-align: center;
`;

export const StatValue = styled.div`
    font-size: 1.05rem;
    font-weight: 800;
    color: ${(p) => p.$accent || "#2B3240"};
`;

export const StatLabel = styled.div`
    font-size: 0.66rem;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: #9AA4B2;
`;

export const Toolbar = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 10px;
`;

export const SearchInput = styled.input`
    flex: 0 0 260px;
    box-sizing: border-box;
    border: 1px solid #E3E8F0;
    border-radius: 8px;
    padding: 9px 12px;
    font-family: Mulish;
    font-size: 0.85rem;
    background: #F7F9FC;
    &:focus { outline: none; border-color: #2F80ED; }
`;

export const Chips = styled.div`
    display: flex;
    gap: 8px;
`;

export const Chip = styled.button`
    border: 1px solid ${(p) => (p.$active ? "#2F80ED" : "#E3E8F0")};
    background: ${(p) => (p.$active ? "#EAF2FE" : "#FFFFFF")};
    color: ${(p) => (p.$active ? "#2F80ED" : "#6B7280")};
    font-family: Mulish;
    font-size: 0.78rem;
    font-weight: 700;
    padding: 6px 14px;
    border-radius: 16px;
    cursor: pointer;
`;

export const Table = styled.div`
    background: #FFFFFF;
    border: 1px solid #EEF1F6;
    border-radius: 14px;
    overflow: hidden;
`;

export const Th = styled.div`
    display: grid;
    /* 1ª coluna (32px) = checkbox de seleção em massa (bulk) — reativar junto com o checkbox */
    grid-template-columns: /* 32px */ 2fr 1.4fr 1.2fr 1.2fr 1fr 80px;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: #F7F9FC;
    font-size: 0.72rem;
    font-weight: 800;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: #6B7280;
`;

export const Tr = styled.div`
    display: grid;
    /* 1ª coluna (32px) = checkbox de seleção em massa (bulk) — reativar junto com o checkbox */
    grid-template-columns: /* 32px */ 2fr 1.4fr 1.2fr 1.2fr 1fr 80px;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    border-top: 1px solid #F2F4F8;
    font-size: 0.86rem;
    color: #2B3240;
`;

export const NameCell = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
`;

export const Avatar = styled.div`
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: ${(p) => p.$color || "#2F80ED"};
    color: #FFFFFF;
    font-size: 0.72rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
`;

export const NameText = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 0;
`;

export const NameMain = styled.span`
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const NameSub = styled.span`
    font-size: 0.72rem;
    color: #2F80ED;
`;

export const RoleAdmin = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: none;
    background: #EAF2FE;
    color: #2F80ED;
    font-family: Mulish;
    font-size: 0.8rem;
    font-weight: 700;
    padding: 6px 10px;
    border-radius: 8px;
    cursor: not-allowed;
`;

export const RoleMember = styled.span`
    color: #2B3240;
    font-size: 0.85rem;
`;

export const RoleSelect = styled.select`
    border: 1px solid ${(p) => (p.$admin ? "#2F80ED" : "#E3E8F0")};
    background: ${(p) => (p.$admin ? "#EAF2FE" : "#FFFFFF")};
    color: ${(p) => (p.$admin ? "#2F80ED" : "#2B3240")};
    font-family: Mulish;
    font-size: 0.8rem;
    font-weight: 700;
    padding: 6px 10px;
    border-radius: 8px;
    cursor: pointer;
    &:focus { outline: none; }
    &:disabled { opacity: 0.6; cursor: not-allowed; }
`;

export const TagBadge = styled.span`
    display: inline-block;
    font-size: 0.72rem;
    font-weight: 700;
    padding: 3px 10px;
    border-radius: 12px;
    background: ${(p) => (p.$operator ? "#EAF2FE" : "#EAF7EE")};
    color: ${(p) => (p.$operator ? "#2F80ED" : "#22A559")};
`;

export const RowActions = styled.div`
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    align-items: center;
`;

export const SendBtn = styled.button`
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: none;
    background: #2F80ED;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 0.9rem;
    text-decoration: none;
`;

export const TrashBtn = styled.button`
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: none;
    background: #FDECEC;
    color: #EF4444;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 0.9rem;
`;
